<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Orders
      </p>
      <ul class="menu-list">
        <li>
          <a class="">General</a>
          <ul>
            <li @click="activeMenuLink = 'orders/order-search'"><router-link to="/orders/order-search"  :class="{'is-active':activeMenuLink === 'orders/order-search'}">Search Orders</router-link></li>
            
          </ul>
        </li>

       
        
      </ul>
      
    </aside>
    
   </div>
</template>

<script>
import OrderMixin from "@/mixins/OrderMixin.js";
//import OrderService from '@/services/OrderService.js';

export default {
  name: 'SideBarOrders',
  components: {
  },
  mixins: [OrderMixin],
  data() {
    return { activeMenuLink: null,
    }
  },
  methods: {
      
  },
  created() {
     this.getAccessToken()
        .then(() => { 
           
        });

        
  },
  mounted() {
    this.activeMenuLink = this.$route.path.substring(1)
    console.log(this.$route.path)

   
  }
}

</script>



